import React, {useEffect, useState} from 'react';
import { useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import MetricChartItem from './metric-chart-item';

const MetricCharts = ({nodoInfo, currentFilters, setFilters}) => {
  const filtersSelected = useSelector((state) => state?.fuse?.dashboard?.dashboard?.filters?.filtersSelected);
  const nodes = useSelector((state) => state?.fuse?.monitoreo?.topologicNodes);
  const [refreshKey, setRefreshKey] = useState(0);
  const [nodesSelect, setNodesSelect] = useState([]);

  const nodeSend = () => {
    const nodesSel = typeof nodoInfo === 'object' && nodoInfo !== null && 'nodeId' in nodoInfo
      ? [{ ...nodoInfo, id: String(nodoInfo.nodeId), nodo: nodoInfo.dsNodo }]
      : nodes;
    return nodesSel
  }
  
  useEffect(() => {
    const updatedNodes = nodeSend();
    setNodesSelect(updatedNodes);
    setRefreshKey((prev) => prev + 1); 
  }, [nodes, nodoInfo]);

  return (
    <Grid container spacing={2} style={{ marginTop: '20px' }}>
      {[0, 1, 2, 3].map((order) => (
        <Grid item lg={6} md={12} sm={12} xs={12} style={{ alignItems: 'center' }} key={order}>
          <MetricChartItem
            key={`${refreshKey}-${order}`} 
            nodes={nodesSelect}
            filters={filtersSelected}
            showDates={false}
            order={order}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default MetricCharts;
